import type { ClientType } from 'entities/onboarding/types';

type AccountFlags = { isCompanyIndividual?: boolean; isCompanySelfServe?: boolean };

// Account type is established at signup, so the onboarding wizard never needs to ask it.
export function deriveClientType(user: AccountFlags | null | undefined): ClientType {
  if (user?.isCompanyIndividual) {
    return 'individual';
  }
  if (user?.isCompanySelfServe) {
    return 'self_serve';
  }
  return 'client';
}
